import { Component, Input } from '@angular/core';

@Component({
  selector: 'js-pdf-viewer',
  templateUrl: './js-pdf.component.html',
  styleUrls: ['./js-pdf.component.scss']
})
export class JsPdfViewerComponent {
  @Input () fileUrl!: string
  
  constructor(){
    console.log('Attempting to fetch PDF at: ', this.fileUrl)
  }
  
  showPlaceholder(){
    this.fileUrl = null
  }
}

